var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ml-4",attrs:{"items":_vm.semesters(),"label":_vm.semesterSelected.value,"item-text":"value","item-value":"key","menu-props":"auto","placeholder":"Wszystkie sesje","single-line":""},model:{value:(_vm.semesterSelected),callback:function ($$v) {_vm.semesterSelected=$$v},expression:"semesterSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }